<template>
  <div id="app">
    <ow-header />
    <router-view/>
  </div>
</template>
<script>
import OwHeader from '@/components/ow-header'
export default {
  components: {
    OwHeader
  }
}
</script>
<style lang="less">
@import 'assets/style/public.less';
</style>
